import { useContext, useCallback } from 'react';
import type { MouseEvent } from 'react';
import styled, { css } from 'styled-components';
import { CommonImage } from '~/components/common/image/CommonImage';
import { ModalContext } from '~/context/ModalContext';
import { colors } from '~/styles/ts/colors';
import { pxVw } from '~/styles/ts/functions';
import { path } from '~/utils/path';

interface Props {
  strokeColor: 'white' | 'primary';
  iconType?: 'circle' | 'default';
  onClick?: (e: MouseEvent) => void | Promise<void>;
}

const Button = styled.button<{ iconType: 'circle' | 'default' }>`
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none;
  line-height: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ iconType }) => css`
    border-radius: ${iconType === 'circle' ? '50%' : 'none'};
    border: ${iconType === 'circle' ? `1px solid ${colors.white}` : 'none'};
    width: ${iconType === 'circle' ? pxVw.SP(80) : 'auto'};
    height: ${iconType === 'circle' ? pxVw.SP(80) : 'auto'};
  `}
`;

export const CloseButton = ({ onClick, strokeColor, iconType = 'default' }: Props) => {
  const { closeModal } = useContext(ModalContext);

  const close: (e: MouseEvent) => void | Promise<void> = useCallback(
    async (e) => {
      onClick && (await onClick(e));
      closeModal();
    },
    [closeModal, onClick],
  );

  return (
    <Button onClick={close} iconType={iconType}>
      <CommonImage
        src={path.image(`/common/icon-close${strokeColor === 'white' ? '-white' : ''}.svg`)}
        width={32}
        height={32}
      />
    </Button>
  );
};
